import Banner from "src/assets/images/website-images/life-health-package-banner.png";
import httpRequest from "src/helpers/httpRequest";
import { useNavigate } from "react-router-dom";
import { convertToKebabCase, parseQueryParams } from "src/helpers/helperFunctions";
import { QueryPath } from "src/lib/constans";
import { Skeleton } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

const AllBrandsPage = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchPackages = async () => {
    if (data.length === 0) {
      setLoader(true);
    }
    const { res, err } = await httpRequest<{ documents: any[] }>({
      path: "/brand/home/getallbrands",
    });
    if (res) {
      setData(res?.documents || []);
    } else {
      toast(err, { type: "error" });
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  // Render all brands in a flat list (no grouping)
  const renderedCards = useMemo(() => {
    if (loader) {
      return Array.from({ length: 12 }).map((_, index) => (
        <div
          key={index}
          className="w-full h-[90px] 2xl:h-[120px] bg-white shadow-all overflow-hidden rounded-md flex items-center justify-center cursor-pointer"
        >
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </div>
      ));
    }

    return data.map((item, index) => (
      <div
        key={item._id || index}
        className="w-full h-[90px] 2xl:h-[120px] bg-white shadow-all rounded-md flex items-center justify-center cursor-pointer"
        onClick={() => {
          navigate(`/brand/${convertToKebabCase(item?.brandName || "")}?${parseQueryParams({
            [QueryPath.brand]: item?._id,
            [QueryPath.brandName]: item?.brandName,
          })}`, {
            state: {
              brand: {
                label: item?.brandName,
                id: item?._id,
              },
            },
          });
        }}
      >
        <img
          src={item?.brandLogo}
          alt={item?.brandName}
          className="max-w-[80%] max-h-[90%] object-contain"
          loading="lazy"
        />
      </div>
    ));
  }, [loader, data, navigate]);

  return (
    <div className="bg-banner-white-image w-full h-full relative 2xl:p-4 p-2">
      <div className="view-area-width mx-auto box-design bg-white flex flex-col 2xl:gap-6 gap-4 2xl:p-4 p-2">
        <img
          src={Banner}
          alt="Banner"
          className="w-full max-h-[44vh] object-cover box-design rounded-lg"
          loading="lazy"
        />
        <div className="grid grid-cols-1 lg:grid-cols-5 2xl:grid-cols-6 gap-4">
          {renderedCards}
        </div>
      </div>
    </div>
  );
};

export default AllBrandsPage;